import React from 'react'
import ReactDOM from 'react-dom'
import { createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import * as Mousetrap from 'mousetrap'
import fontawesome from '@fortawesome/fontawesome'
import solid from '@fortawesome/fontawesome-free-solid'

import App from './pages/App'
import NewLogo from './pages/NewLogo'
import BrandGuideline from './pages/BrandGuideline'
import Dashboard from './pages/Dashboard'
import Success from './pages/Success'
import Terms from './pages/Terms'
import About from './pages/About'
import Policy from './pages/Policy'
import Pricing from './pages/Pricing'
// import OutOfService from './pages/OutOfService'

import rootReducer from './reducers'

import './index.css'

// Add FontAwesome Solid to FA library so we can use it anywhere
fontawesome.library.add(solid)


// Setup middlewares
const middleware = [ thunk ]
if (process.env.NODE_ENV !== 'production') {
  middleware.push(createLogger())
}
Mousetrap.bind('left', ()=> store.dispatch({type:'KEY_LEFT'}))
Mousetrap.bind('right', ()=> store.dispatch({type:'KEY_RIGHT'}))

// Setup global states' store
const store = createStore(
  rootReducer,
  applyMiddleware(...middleware)
)

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <App>
        <Route exact path="/" component={NewLogo} />
        <Route path="/guideline/:id" component={BrandGuideline} />
        <Route path="/dashboard" component={Dashboard} />
        <Route path="/success" component={Success} />
        <Route path="/tos" component={Terms} />
        <Route path="/about" component={About} />
        <Route path="/privacy" component={Policy} />
        <Route path="/pricing" component={Pricing} />
      </App>
    </Router>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js